import { styled } from "simplydo/react/styled";
import { Card } from "simplydo/react/ui/card";

const HomeBlock = styled(Card)<{ $width?: 1 | 2 | 3 }>`
  width: 100%;
  flex: 0;
  grid-column: span
    ${(props) => (props.theme.sizes.isComputer ? (props.$width ?? 1) : 1)};
  margin: 0 !important;
  height: fit-content;

  padding: 18px 20px 20px 20px;
`;

export default HomeBlock;
